<div class="header" data-testid="select-tag-title">
  {{ 'm/task-process/select_tag/move_to_pending_modal_title' | translate }}
</div>
<ion-content>
  <ion-list lines="none">
    <ion-radio-group [(ngModel)]="result">
      <ion-item data-testid="select-tag-yes-item">
        <ion-label>{{ 'm/task-process/select_tag/move_to_pending_modal_yes' | translate: { team: team } }}</ion-label>
        <ion-radio
          data-testid="select-tag-yes-radio"
          slot="start"
          color="primary"
          [value]="MoveToPendingModalResultEnum.TagAndMoveToPending"></ion-radio>
      </ion-item>
      <ion-item data-testid="select-tag-no-item">
        <ion-label>{{ 'm/task-process/select_tag/move_to_pending_modal_no' | translate: { team: team } }}</ion-label>
        <ion-radio
          data-testid="select-tag-no-radio"
          slot="start"
          color="primary"
          [value]="MoveToPendingModalResultEnum.Tag"></ion-radio>
      </ion-item>
    </ion-radio-group>
  </ion-list>
</ion-content>
<div class="footer">
  <ion-button data-testid="select-tag-ok" (click)="ok(result)" [disabled]="result === undefined">
    {{ 'm/ok' | translate }}
  </ion-button>
  <ion-button data-testid="select-tag-cancel" (click)="cancel()" fill="outline">
    {{ 'm/cancel' | translate }}
  </ion-button>
</div>
